export default __webpack_public_path__ + "static/media/icon-remar-full.5b5095e4.svg";